export const BASEURL = "https://akra-backend-production.up.railway.app/api"; 
